import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button, Panel } from '../../../atoms'
import { EditTable } from '../../../organisms'
import SidebarLayout from '../../_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  guide_notification_types: {
    guide_notification_types: IJsonResponse
  }
  user: IJsonResponse
}

const COLUMNS = [
  {
    name: I18n.t('generic.id'),
    field: 'id',
    required: false,
    readOnly: true,
  },
  {
    name: I18n.t('generic.name'),
    field: 'name',
    required: true,
  },
  {
    name: 'アプリ内 タイトル',
    field: 'activity_title',
    required: false,
  },
  {
    name: 'Active',
    field: 'is_active',
    required: false,
    renderElement: record => (
      <div style={{ textAlign: 'center' }}>{record.is_active ? '◯' : '✕'}</div>
    ),
  },
  {
    name: 'アクティビティ',
    field: 'is_activity',
    required: false,
    renderElement: record => (
      <div style={{ textAlign: 'center' }}>{record.is_activity ? '◯' : ''}</div>
    ),
  },
  {
    name: 'メール',
    field: 'is_email',
    required: false,
    renderElement: record => (
      <div style={{ textAlign: 'center' }}>{record.is_email ? '◯' : ''}</div>
    ),
  },
  {
    name: 'プッシュ',
    field: 'is_mobile_push',
    required: false,
    renderElement: record => (
      <div style={{ textAlign: 'center' }}>{record.is_mobile_push ? '◯' : ''}</div>
    ),
  },
]

const AgentGuideNotificationTypesIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('ガイド通知タイプ')

  const { data: userData } = utilService.getDataFromJson(props.user)
  const { data: guideNotificationTypesList, pagination } = agentService.getDataFromJson(
    props.guide_notification_types.guide_notification_types
  )

  const [guideNotificationTypes, setGuideNotificationTypes] = React.useState(
    guideNotificationTypesList
  )

  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await agentService.deleteGuideNotificationType(id)
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setGuideNotificationTypes(guideNotificationTypes.filter(t => t.id !== id))
    },
    [guideNotificationTypes]
  )

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel
          title={
            <Heading>
              <span>ガイド通知タイプ</span>
              <Button primary={true}>
                <a href="/agent/guide_notification_types/new">{I18n.t('generic.create')}</a>
              </Button>
            </Heading>
          }
        >
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={guideNotificationTypes}
            pagination={pagination}
            handleDelete={handleClickDelete}
            getEditLink={({ id }) => `/agent/guide_notification_types/${id}/edit`}
            getRowLink={record => `/agent/guide_notification_types/${record.id}`}
          />
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Panel {
    max-width: none;
  }
`

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default AgentGuideNotificationTypesIndex
